export default "__VITE_ASSET__Bk4OX$dJ__"